<script>
	import base from "../stores/base";
	import router from "../stores/router";
	import UISubcategoryButton from "../ui/UISubcategoryButton.svelte";

	export let subcategories = [];
	console.log()
</script>

<div class="UISubcategoryList" >
	{#each subcategories as subcategory}
		<UISubcategoryButton on:click={() => router.push("/" + subcategory)}>
			{$base.categories[subcategory][$base.lang]}
		</UISubcategoryButton>
	{/each}
</div>

<style global>
	.UISubcategoryList {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: stretch;
		gap: 0.5em;
		margin-bottom:1em;
	}
	.UISubcategoryList > * {
		flex: 0 0 1;
	}
</style>
